import { useCallback, useState } from 'react';

interface UseBooleanState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

const useBooleanState = (initialValue = false): UseBooleanState => {
  const [isOpen, setOpen] = useState(initialValue);

  const open = useCallback(() => {
    setOpen(true);
  }, []);

  const close = useCallback(() => {
    setOpen(false);
  }, []);

  const toggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  return {
    isOpen,
    open,
    close,
    toggle
  };
};

export default useBooleanState;
